const searchMock = {
	count: 3,
	total_pages: 1,
	results: []
};

export { searchMock };
